import { useQuery, UseQueryOptions } from 'react-query';
import { RobotDevice } from '../../types';
import { getRobotTutorials } from '../api';
import { RobotTutorial } from '../types';
import { robotTutorialsKeys } from './keys';

export const useGetRobotTutorials = <TData = RobotTutorial[]>(
  robot: RobotDevice | undefined,
  options?: UseQueryOptions<
    RobotTutorial[],
    unknown,
    TData,
    ReturnType<typeof robotTutorialsKeys.tutorials>
  >
) => {
  const robotId = robot?.id ?? '';

  const query = useQuery({
    queryKey: robotTutorialsKeys.tutorials(robotId),
    queryFn: () => getRobotTutorials(robot?.websocketConnection?.ipAddress),
    enabled:
      robot?.id !== undefined &&
      robot?.websocketConnection?.ipAddress !== undefined,
    ...options,
  });

  return query;
};
